import fetch, { doGet } from '../../tools/axios'
import { GIFT_TYPE } from '@/tools/constant'

export default {
  searchGift (keyW, page, status, category, cb) {
    return fetch('get', `/search?type=gift&object_type=normal&keyword=${keyW}&page=${page || 1}&status=${status}&category=${category || ''}`, {}, cb)
  },
  searchFlash (keyW, page, status, category, cb) {
    return fetch('get', `/search?type=gift&object_type=flash&keyword=${keyW}&page=${page || 1}&status=${status}&category=${category || ''}`, {}, cb)
  },
  searchNeed (keyW, page, status, category, cb) {
    return fetch('get', `/search?type=need&keyword=${keyW}&page=${page || 1}&status=${status}&category=${category || ''}`, {}, cb)
  },
  searchMember (keyW, page, category, cb, love = '') {
    return fetch('get', `/user?type=user&keyword=${keyW}&page=${page || 1}&category=${category || ''}&love=${love || ''}`, {}, cb)
  },
  searchLovebox (keyW, page, status, category, cb) {
    return fetch('get', `/search?type=lovebox&keyword=${keyW}&page=${page || 1}&status=${status}&category=${category || ''}`, {}, cb)
  },
  searchStories (keyW, page, category, cb) {
    return fetch('get', `/search?type=story&keyword=${keyW}&page=${page || 1}&category=${category || ''}`, {}, cb)
  },
  searchMyGift (keyword, userId, page, perPage, type = GIFT_TYPE.NORMAL) {
    return doGet(`/gifts?user_id=${userId}&keyword=${keyword}&page=${page || 1}&perPage=${perPage}&type=${type}`)
  },
  searchLovebox2 (keyW, page, perPage, status) {
    return doGet(`/search?type=lovebox&keyword=${keyW}&page=${page || 1}&perPage=${perPage}&status=${status}`)
  },
  getHotGiftList (page, perPage) {
    return doGet(`/gifts/home?page=${page || 1}&perPage=${perPage}&on_pool=1&sort=trends`)
  },
  searchRecommendGift ({ keyW, page = 1, status, remaining = 1, objectType, category, perPage = 15 }) {
    return doGet(`/search?type=gift&keyword=${keyW}&page=${page || 1}&status=${status}&category=${category || ''}&object_type=${objectType}&remaining=${remaining}`)
  },
  searchCarbonLabelling (keyW, page, perPage) {
    return doGet(`/carbonLabelling?keyword=${keyW}&page=${page || 1}&perPage=${perPage}`)
  }
}
